import {get} from 'lodash/fp';
import {createSelector} from 'reselect';

import {
  FAILED_TO_PROCESS_REQUEST_EXCEPTION,
  SERVER_IS_DOWN_EXCEPTION,
} from '/enum/errors.enum';

import {apiError as apiErrorState} from './root.selector';

export const getServerIsDownErrorState = createSelector(
  apiErrorState,
  get(SERVER_IS_DOWN_EXCEPTION),
);

export const getFailedToProcessRequestErrorState = createSelector(
  apiErrorState,
  get(FAILED_TO_PROCESS_REQUEST_EXCEPTION),
);
